import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=72fa355a&scoped=true"
import script from "./HeatMap.vue?vue&type=script&lang=js"
export * from "./HeatMap.vue?vue&type=script&lang=js"
import style0 from "./HeatMap.vue?vue&type=style&index=0&id=72fa355a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa355a",
  null
  
)

export default component.exports